module.exports = __webpack_public_path__ + "img/header-weddingRingsFacetes.44f4424.webp";